export const getURLPathID = (path: string, indexID?: number) => {
    const splitPath = path.split("/");

    if(indexID){
        return splitPath[indexID];
    }
    return splitPath[splitPath.length - 1];
}